import Start from "./Start";
import Form from "./Form";
import MovieWithButtonsView from "./MovieWithButtonsView";
import BloopersView from "./BloopersView";

const routes = [
	{
		component: Start,
		path: '/'
	},
	{
		component: Form,
		path: '/form'
	},
	{
		component: MovieWithButtonsView,
		path: '/movie'
	},
	{
		component: BloopersView,
		path: '/bloopers'
	}
];

export default routes;